import { useSSOAuthInitiator } from './use-sso-auth-initiator';
import { useSSOAuthResolver } from './use-sso-auth-resolver';

export const useSSOAuthFlow = (): void => {
  useSSOAuthInitiator();
  useSSOAuthResolver();
};
